import React from 'react'
import R from 'ramda'
import classNames from 'classnames'
import { 
  mapProps 
} from 'recompose'

const getDifficulty = R.compose(
  arr => R.times(i => R.propOr(false, i, arr), 3),
  R.map(() => true),
  R.range(0),
  R.pathOr(null, ['difficulty'])
)

const Difficulty = ({ difficulty, className }) => (
  <ul 
    className={classNames({
      'my0 list-reset flex': true,
      [className]: className
    })}
  >
    {difficulty.map(star => (
      <li 
        className={classNames({
          'mr1 star': true,
          'filled': star,
        })}
      />
    ))}
  </ul>
)

const enhance = mapProps(({ frontmatter, ...props }) => ({
  difficulty: getDifficulty(frontmatter),
  ...props
}))

export default enhance(Difficulty)


// WEBPACK FOOTER //
// ./src/components/Difficulty.js